<template>
  <footer
    class="platform-footer"
    :class="{ 'platform-footer--compact': authStore.isAuthenticated }"
  >
    <div
      v-if="!authStore.isAuthenticated"
      class="platform-footer__main"
    >
      <div class="platform-footer__brand">
        <router-link
          to="/"
          aria-label="Indiefy"
        >
          <img
            :src="themeStore.isDark ? logoWhite : logoDark"
            alt="Indiefy"
            width="112"
            height="30"
          >
        </router-link><p>{{ $t('refresh.made-independent') }}</p><div class="platform-footer__social">
          <a
            v-for="social in socials"
            :key="social.name"
            :href="social.url"
            :aria-label="social.name"
          ><i
            :class="social.icon"
            aria-hidden="true"
          /></a>
        </div>
      </div>
      <nav :aria-label="$t('refresh.platform')">
        <span>{{ $t('refresh.platform') }}</span><router-link to="/distribute">
          {{ $t('navigation.distribute') }}
        </router-link><router-link to="/pro/yearly">
          {{ $t('navigation.pro-yearly') }}
        </router-link><router-link to="/artists-catalog">
          {{ $t('refresh.community') }}
        </router-link><router-link to="/blog">
          {{ $t('navigation.blog') }}
        </router-link>
      </nav>
      <nav :aria-label="$t('navigation.tools')">
        <span>{{ $t('navigation.tools') }}</span><router-link to="/promotion">
          {{ $t('refresh.footer-promotion') }}
        </router-link><router-link to="/cover-editor">
          {{ $t('refresh.footer-artwork') }}
        </router-link><router-link to="/mastering">
          {{ $t('refresh.footer-mastering') }}
        </router-link><a href="https://smartlinks.indiefy.net/">{{ $t('refresh.footer-smartlinks') }}</a><a href="https://boletra.com/">{{ $t('refresh.footer-boletra') }}</a><router-link to="/trackmuse">
          {{ $t('refresh.footer-trackmuse') }}
        </router-link>
      </nav>
      <div class="platform-footer__preferences">
        <label for="footer-language">{{ $t('general.language') }}</label><select
          id="footer-language"
          :value="locale"
          @change="setLanguage($event.target.value)"
        >
          <option
            v-for="language in languages"
            :key="language.code"
            :value="language.code"
          >
            {{ language.name }}
          </option>
        </select><button @click="themeStore.toggleDarkMode()">
          <GrowthIcon name="moon" />{{ $t('refresh.theme') }}
        </button>
      </div>
    </div>
    <div class="platform-footer__bottom">
      <span>© {{ new Date().getFullYear() }} Indiefy</span><nav :aria-label="$t('refresh.footer')">
        <a href="https://help.indiefy.net/">{{ $t('navigation.help') }}</a><router-link to="/terms-and-conditions">
          {{ $t('refresh.terms') }}
        </router-link><router-link to="/privacy-policy">
          {{ $t('refresh.privacy') }}
        </router-link><router-link to="/cookie-policy">
          {{ $t('general.cookies') }}
        </router-link>
      </nav>
    </div>
  </footer>
</template>
<script setup>
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/store/auth';
import { useThemeStore } from '@/store/theme';
import { getAvailableLanguages, setLanguage } from '@/i18n';
import GrowthIcon from '@/components/growth/GrowthIcon.vue';
import logoDark from '@/assets/images/logo-dark.png';
import logoWhite from '@/assets/images/logo-white.png';
const authStore = useAuthStore();
const themeStore = useThemeStore();
const { locale } = useI18n();
const languages = getAvailableLanguages();
const socials = [
  { name: 'Facebook', icon: 'fab fa-facebook-f', url: 'https://www.facebook.com/indiefyapp' },
  { name: 'X', icon: 'fab fa-x-twitter', url: 'https://x.com/indiefyapp' },
  { name: 'Instagram', icon: 'fab fa-instagram', url: 'https://www.instagram.com/indiefyapp' },
  { name: 'YouTube', icon: 'fab fa-youtube', url: 'https://www.youtube.com/@indiefymusic' },
  { name: 'Spotify', icon: 'fab fa-spotify', url: 'https://open.spotify.com/user/0prvlevxuj0z0qizh2o7zd5hy' },
];
</script>
